import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { cn } from '@/lib/utils';
import { resolveLocalizedText } from '@/utils/localizedText';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function MultipleChoiceRenderer({
  question,
  value,
  isInvalid,
  onChange,
}: PreVisitQuestionRendererProps) {
  const { i18n } = useTranslation('intake');
  const selectedCodes = Array.isArray(value) ? value : [];

  function toggleOption(optionCode: string) {
    if (selectedCodes.includes(optionCode)) {
      onChange(
        selectedCodes.filter(function keep(code) {
          return code !== optionCode;
        })
      );
      return;
    }
    onChange([...selectedCodes, optionCode]);
  }

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} />
      <div
        className={cn(
          'flex flex-wrap gap-2 p-2 rounded-xl',
          isInvalid ? 'border border-zooerrorborder ring-1 ring-zooerrorborder' : ''
        )}
      >
        {question.options.map(function renderOption(option) {
          const isSelected = selectedCodes.includes(option.code);
          return (
            <button
              key={option.code}
              type="button"
              aria-pressed={isSelected}
              onClick={function toggle() {
                toggleOption(option.code);
              }}
              className={cn(
                'flex items-center gap-1.5 px-4 py-2.5 rounded-xl text-sm font-semibold border transition-colors',
                isSelected
                  ? 'bg-zoovpalelavender border-zooprimary text-zooprimary'
                  : 'bg-zoowhite border-zooborder text-zooindigo'
              )}
            >
              {isSelected ? <Icon name="CheckCircle" /> : null}
              {resolveLocalizedText(option.labelEn, option.labelPl, i18n.language)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
